import React from 'react';
import axios from 'axios';
import EmptyStateBasic from 'shared/components/EmptyStateBasic';
import {
	PageSection,
  PageSectionVariants,
  Content,
  Bullseye,
  Spinner,
  ContentVariants,
  List,
  ListItem,
  Flex,
  FlexItem,
  Panel,
  PanelMain,
  PanelMainBody,
  PanelHeader,
  Divider
} from '@patternfly/react-core';

import { AuthContext } from 'shared/context/AuthContext';

class Resources extends React.Component {
  static contextType = AuthContext
  constructor(props) {
    super(props);
    this.state = {
      resources_data: [],
      isLoadedResources: false,
      isToggleOn: true,
      location: "random"
    };
    // This binding is necessary to make `this` work in the callback
    this.GetMediaUrl = this.GetMediaUrl.bind(this);
  }
  Sum = (a, b) => {
    return a + b;
  }
  GetResources = async (args) => {
    fetch(`${this.props.state.api_url}/ti/api/v1${args}`, {
        'method': 'GET',
      }
    )
    .then(resp => resp.json())
    .then(resp => this.setState({ 
      resources_data: resp, 
      isLoadedResources: true
    }))
    .catch(err => this.setState({ error: err, isLoadedResources: false }));
  }

  GetMediaUrl = (url, file_name) => {
    axios({
        url: url, //your url
        method: 'get',
        responseType: 'blob'
    }).then((response) => {
        const urla = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
        const link = document.createElement('a');
        link.href = urla;
        link.setAttribute('download', `${file_name}.${response.data.type}`); //or any other extension
        document.body.appendChild(link);
        //link.click(); // to download
        link.remove();
        window.open(link, '_blank', 'noreferrer');
    }).catch((error) => console.log(error));

    this.setState(prevState => ({
      isToggleOn: !prevState.isToggleOn
    }));
  }
  async componentDidMount() {
    this.props.state.activeItem = window.location.pathname;
    this.setState({isLoadedResources: false});
    if(await this.GetResources(window.location.pathname)) {
      this.setState({isLoadedResources: true});
    }
  }
  componentDidUpdate(newProps, prevProps) {
    prevProps.location = window.location.pathname
    if (newProps.state.location !== prevProps.location) {
      // console.log(newProps.state.location, prevProps.location)
      if(this.GetResources(window.location.pathname)) {
        prevProps.location = window.location.pathname
        newProps.state.location = window.location.pathname
      }
      // console.log(newProps.state.location, prevProps.location)
    }
  }
  render() {
    if (this.state.isLoadedResources === false) {
      return (
        <React.Fragment>
          <Bullseye style={{ height: '100vh' }}>
            <Content component="h1" style={{textAlign: 'center', color: 'silver'}}>Resources ...</Content>
            {this.state.isLoadedResources === false
              ? <Bullseye><Spinner  size="xl" aria-label="" /></Bullseye>
              : <Bullseye className="pf-u-hidden"><Spinner  size="xl" aria-label="" className="pf-u-hidden" /></Bullseye>
            }
          </Bullseye>
        </React.Fragment>
      )
    }
    if(Object.keys(this.state.resources_data.resources).length === 0) {
      return (
        <EmptyStateBasic />
      )
    }
    if (this.state.isLoadedResources === true && Object.keys(this.state.resources_data.resources).length > 0) {
      const guest_resources_data = this.state.resources_data.resources.guest;
      const superuser_resources_data = this.state.resources_data.resources.superuser;
      const execution_time = this.state.resources_data.execution_time;
      return (
        <React.Fragment>
            {/* <Banner>
              <Level>
                <LevelItem></LevelItem>
                <LevelItem title="Execution time">
                  { execution_time }
                </LevelItem>
              </Level>
            </Banner> */}
            {this.context.state.isAuthUser && this.context.state.userProfile.is_superuser && Object.keys(superuser_resources_data.category_name).length > 0 &&
              <>
              <PageSection variant={PageSectionVariants.default}>
              <Content>
                <Content component={ContentVariants.h1}>Linki </Content>
                <Content component={ContentVariants.p}>Dla użytkownika {this.context.state.userProfile.username}</Content>
              </Content>
              <Flex>
                {Object.entries(superuser_resources_data).map(([a, item], i) => {
                  return (
                    Object.entries(item).map(([category_name, e], j) => {
                      return (
                        <FlexItem key={j} style={{ marginBottom: '15px' }}>
                          <Panel variant="raised">
                            <PanelHeader>{category_name} </PanelHeader>
                            <Divider />
                            <PanelMain>
                              <PanelMainBody>
                                <Content>
                                  <List isPlain isBordered>
                                    {Object.entries(e).map(([u, res]) => {
                                      return (
                                        <ListItem key={res.uid}>
                                          {/* for superuser */}
                                          {res.resources_url !== "" && res.resources_url !== "None" && res.only_superuser &&
                                            <Content component="a" target="_blank" href={res.resources_url}>{res.resources_name}</Content>
                                          }
                                          {res.resources_path !== "" && res.resources_path !== "None" && res.only_superuser &&
                                            <Content component="a" onClick={() => this.GetMediaUrl(`${this.props.state.api_url}/${this.props.state.django_media_dir}/${res.resources_path}`, res.resources_name)}>{res.resources_name}</Content>
                                          }
                                        </ListItem>
                                      )  
                                    })} 
                                  </List>
                                </Content>
                              </PanelMainBody>
                            </PanelMain>
                          </Panel>
                        </FlexItem>
                      )
                    })
                  )
                })}
                </Flex>
                </PageSection>
                </>
              }
              <Divider />
              <PageSection variant={PageSectionVariants.light}>
              <Flex>
              {Object.entries(guest_resources_data).map(([a, item], i) => {
                return (
                  Object.entries(item).map(([category_name, e], j) => {
                    return (
                      <FlexItem key={j} style={{ marginBottom: '15px' }}>
                        <Panel variant="raised">
                          <PanelHeader>{category_name}</PanelHeader>
                          <Divider />
                          <PanelMain>
                            <PanelMainBody>
                              <Content>
                                <List isPlain isBordered>
                                  {Object.entries(e).map(([u, res]) => {
                                    return (
                                      <ListItem key={res.uid}>
                                        {res.resources_url !== "" && res.resources_url !== "None" && res.only_superuser === false &&
                                          <Content component="a" target="_blank" href={res.resources_url}>{res.resources_name}</Content>
                                        }
                                        {res.resources_path !== "" && res.resources_path !== "None" && res.only_superuser === false &&
                                          <Content component="a"  onClick={() => this.GetMediaUrl(`${this.props.state.api_url}/${this.props.state.django_media_dir}/${res.resources_path}`, res.resources_name)}>{res.resources_name}</Content>
                                        }
                                      </ListItem>
                                    )  
                                  })} 
                                </List>
                              </Content>
                            </PanelMainBody>
                          </PanelMain>
                        </Panel>
                      </FlexItem>
                    )
                  })
                )
              })}
              </Flex>
            </PageSection>
        </React.Fragment>
      )
    }
  }
}
export default Resources;
